var _defs, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack1136({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "15 6.93 9.07 6.93 9.07 1 6.93 1 6.93 6.93 1 6.93 1 9.07 6.93 9.07 6.93 15 9.07 15 9.07 9.07 15 9.07 15 6.93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack1136);
export default __webpack_public_path__ + "static/media/Symbolpack_1_136.ea80353faefde9c59e4e76073c60cf01.svg";
export { ForwardRef as ReactComponent };